import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {Usage} from '@app/core/model/Usage';

@Injectable({providedIn: 'root'})
export class UsageService {
  private endPoint = '/billing/usage';

  constructor(private http: HttpClient) {
  }

  getUsage(
    scadaMeterId: number,
    meterAccountEid: number,
    startDate: string,
    endDate: string,
    featureGraph: boolean,
    featureBill: boolean,
    featureReport: boolean,
    featureDashboard: boolean
  ): Observable<Usage> {
    const endpoint = `${environment.apiUrl}${this.endPoint}`
      + `?scadaMeterId=${scadaMeterId}`
      + `&meterAccountEid=${meterAccountEid}`
      + `&startDate=` + encodeURIComponent(startDate)
      + `&endDate=` + encodeURIComponent(endDate)
      + `&featureGraph=` + featureGraph
      + `&featureReport=` + featureReport
      + `&featureDashboard=` + featureDashboard
      + `&featureBill=` + featureBill;
    return this.http.get<Usage>(endpoint);
  }
}
